import { render, staticRenderFns } from "./EsgLcaEmissionAmountManagementByProcess.vue?vue&type=template&id=39b1a69e&scoped=true"
import script from "./EsgLcaEmissionAmountManagementByProcess.vue?vue&type=script&lang=js"
export * from "./EsgLcaEmissionAmountManagementByProcess.vue?vue&type=script&lang=js"
import style0 from "./EsgLcaEmissionAmountManagementByProcess.vue?vue&type=style&index=0&id=39b1a69e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b1a69e",
  null
  
)

export default component.exports